import React from 'react'

function Productsheading() {
  return (
    <div>
  <h1 className="text-center font-poppins mt-28 mb-4  text-6xl md:text-8xl font-bold text-white">
    Products To <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-cyan-600 to-sky-400">Explore</span>
  </h1>
</div>

  )
}

export default Productsheading